// ZIP Code to Hardiness Zone Mapping
// Strategic selection of zip codes representing major population centers in each zone
// Falls back to state default zone for unmapped zip codes

export const zipCodeZoneMapping = {
  // ALABAMA - Zones 7a, 7b, 8a, 8b
  '35007': '7a', // Alexander City
  '35801': '7a', // Huntsville
  '36101': '7b', // Montgomery
  '35203': '7b', // Birmingham
  '36801': '8a', // Auburn
  '36330': '8a', // Dothan
  '36602': '8b', // Mobile
  
  // ALASKA - Zones 3a-7a (varies greatly)
  '99701': '3a', // Fairbanks
  '99501': '4b', // Anchorage
  '99801': '6a', // Juneau
  '99901': '7a', // Ketchikan
  
  // ARIZONA - Zones 4b-10a
  '86001': '4b', // Flagstaff
  '85701': '9a', // Tucson
  '85001': '9b', // Phoenix
  '85364': '10a', // Yuma
  
  // ARKANSAS - Zones 6b, 7a, 7b, 8a
  '72701': '6b', // Fayetteville
  '72201': '7a', // Little Rock
  '71601': '7b', // Pine Bluff
  '71730': '8a', // Camden
  
  // CALIFORNIA - Zones 5a-10b
  '96001': '5a', // Redding (mountains)
  '93101': '9b', // Santa Barbara
  '90210': '10a', // Beverly Hills
  '92101': '10b', // San Diego
  '94102': '10a', // San Francisco
  '95814': '9a', // Sacramento
  
  // COLORADO - Zones 3a-7a
  '80424': '3a', // Breckenridge
  '80301': '5a', // Boulder
  '80202': '5b', // Denver
  '81001': '6a', // Pueblo
  '81501': '6b', // Grand Junction
  
  // CONNECTICUT - Zones 5b, 6a, 6b
  '06103': '6a', // Hartford
  '06511': '6b', // New Haven
  '06901': '6b', // Stamford
  
  // DELAWARE - Zones 6b, 7a
  '19801': '6b', // Wilmington
  '19901': '7a', // Dover
  
  // FLORIDA - Zones 8b-10b
  '32301': '8b', // Tallahassee
  '32601': '9a', // Gainesville
  '32801': '9b', // Orlando
  '33101': '10a', // Miami
  '33701': '9b', // St. Petersburg
  '33401': '10a', // West Palm Beach
  '33901': '10a', // Fort Myers
  '33139': '10b', // Miami Beach
  
  // GEORGIA - Zones 7a, 7b, 8a, 8b
  '30309': '7b', // Atlanta
  '31401': '8b', // Savannah
  '31201': '8a', // Macon
  '30901': '7b', // Augusta
  '31601': '8a', // Valdosta
  
  // HAWAII - Zones 10a, 10b
  '96801': '10b', // Honolulu
  '96720': '10a', // Hilo
  
  // IDAHO - Zones 3a-7a
  '83025': '3a', // Jackson (mountains)
  '83201': '4b', // Pocatello
  '83702': '6a', // Boise
  '83814': '5a', // Coeur d'Alene
  
  // ILLINOIS - Zones 5a-6b
  '60601': '6a', // Chicago
  '62701': '6a', // Springfield
  '61602': '5b', // Peoria
  '62901': '6b', // Carbondale
  
  // INDIANA - Zones 5a-6b
  '46201': '6a', // Indianapolis
  '46802': '5b', // Fort Wayne
  '47708': '6b', // Evansville
  
  // IOWA - Zones 4b-5b
  '50309': '5a', // Des Moines
  '52240': '5a', // Iowa City
  '51501': '4b', // Council Bluffs
  
  // KANSAS - Zones 5b-7a
  '66603': '6a', // Topeka
  '67202': '6b', // Wichita
  '66762': '7a', // Pittsburg
  
  // KENTUCKY - Zones 6a-7a
  '40202': '6b', // Louisville
  '40508': '6b', // Lexington
  '42101': '6b', // Bowling Green
  '42001': '7a', // Paducah
  
  // LOUISIANA - Zones 8a-9a
  '70112': '9a', // New Orleans
  '70801': '8b', // Baton Rouge
  '71101': '8a', // Shreveport
  '70501': '9a', // Lafayette
  
  // MAINE - Zones 3b-5b
  '04101': '5b', // Portland
  '04401': '4b', // Bangor
  '04736': '3b', // Caribou
  
  // MARYLAND - Zones 6a-7a
  '21201': '7a', // Baltimore
  '20850': '6b', // Rockville
  '21801': '7a', // Salisbury
  
  // MASSACHUSETTS - Zones 5a-6b
  '02101': '6b', // Boston
  '01103': '5b', // Springfield
  '02601': '6b', // Cape Cod
  
  // MICHIGAN - Zones 3b-6a
  '48201': '6a', // Detroit
  '49503': '5b', // Grand Rapids
  '48823': '5a', // East Lansing
  '49855': '3b', // Iron Mountain
  
  // MINNESOTA - Zones 3a-4b
  '55401': '4b', // Minneapolis
  '55101': '4a', // St. Paul
  '55802': '3b', // Duluth
  '56001': '4a', // Mankato
  
  // MISSISSIPPI - Zones 7b-9a
  '39201': '8a', // Jackson
  '39501': '9a', // Gulfport
  '38801': '7b', // Tupelo
  
  // MISSOURI - Zones 5b-7a
  '63101': '6b', // St. Louis
  '64108': '6a', // Kansas City
  '65201': '6a', // Columbia
  '63801': '7a', // Cape Girardeau
  
  // MONTANA - Zones 3a-5b
  '59718': '3a', // Bozeman
  '59101': '4a', // Billings
  '59801': '4b', // Missoula
  '59601': '4a', // Helena
  
  // NEBRASKA - Zones 4b-5b
  '68102': '5a', // Omaha
  '68508': '5a', // Lincoln
  '69101': '4b', // North Platte
  
  // NEVADA - Zones 4b-9a
  '89101': '9a', // Las Vegas
  '89501': '6a', // Reno
  '89801': '5a', // Elko
  
  // NEW HAMPSHIRE - Zones 3b-5b
  '03301': '5a', // Concord
  '03101': '5b', // Manchester
  '03570': '3b', // Berlin
  
  // NEW JERSEY - Zones 6a-7a
  '08608': '6b', // Trenton
  '07102': '6b', // Newark
  '08401': '7a', // Atlantic City
  
  // NEW MEXICO - Zones 4b-8a
  '87501': '6a', // Santa Fe
  '87102': '7a', // Albuquerque
  '88001': '8a', // Las Cruces
  '87740': '4b', // Taos
  
  // NEW YORK - Zones 3b-6b
  '10001': '6b', // Manhattan
  '14201': '6a', // Buffalo
  '13201': '5b', // Syracuse
  '12601': '5b', // Poughkeepsie
  '12901': '4a', // Plattsburgh
  
  // NORTH CAROLINA - Zones 6a-8a
  '28202': '7b', // Charlotte
  '27601': '7a', // Raleigh
  '28801': '6b', // Asheville
  '27889': '8a', // Wilmington
  
  // NORTH DAKOTA - Zones 3a-4a
  '58102': '3b', // Fargo
  '58501': '3a', // Bismarck
  '58201': '3a', // Grand Forks
  
  // OHIO - Zones 5a-6b
  '43215': '6a', // Columbus
  '44113': '6a', // Cleveland
  '45202': '6b', // Cincinnati
  '45401': '6a', // Dayton
  
  // OKLAHOMA - Zones 6a-7b
  '73102': '7a', // Oklahoma City
  '74103': '6b', // Tulsa
  '73701': '6a', // Enid
  
  // OREGON - Zones 4b-9a
  '97201': '9a', // Portland
  '97401': '8b', // Eugene
  '97701': '6a', // Bend
  '97914': '4b', // Burns
  
  // PENNSYLVANIA - Zones 5a-6b
  '19102': '6b', // Philadelphia
  '15222': '6a', // Pittsburgh
  '17101': '6b', // Harrisburg
  '18015': '6a', // Bethlehem
  
  // RHODE ISLAND - Zones 6a-6b
  '02903': '6b', // Providence
  '02840': '6b', // Newport
  
  // SOUTH CAROLINA - Zones 7b-8b
  '29201': '8a', // Columbia
  '29401': '8b', // Charleston
  '29601': '7b', // Greenville
  '29501': '8a', // Florence
  
  // SOUTH DAKOTA - Zones 3b-5a
  '57701': '4a', // Rapid City
  '57104': '4b', // Sioux Falls
  '57401': '4a', // Aberdeen
  
  // TENNESSEE - Zones 6a-7b
  '37201': '7a', // Nashville
  '38103': '7b', // Memphis
  '37402': '7a', // Chattanooga
  '37902': '6b', // Knoxville
  
  // TEXAS - Zones 6b-9b
  '75201': '8a', // Dallas
  '77002': '9a', // Houston
  '78701': '8b', // Austin
  '78201': '9a', // San Antonio
  '79901': '8a', // El Paso
  '76102': '7b', // Fort Worth
  '79601': '7a', // Abilene
  '78501': '9b', // McAllen
  
  // UTAH - Zones 4a-7a
  '84101': '6b', // Salt Lake City
  '84601': '6a', // Provo
  '84770': '7a', // St. George
  '84321': '5a', // Logan
  
  // VERMONT - Zones 3b-5a
  '05601': '4a', // Montpelier
  '05401': '4b', // Burlington
  '05819': '3b', // Lyndonville
  
  // VIRGINIA - Zones 5b-7a
  '23219': '7a', // Richmond
  '23510': '7a', // Norfolk
  '20105': '6b', // Reston
  '24016': '6b', // Roanoke
  
  // WASHINGTON - Zones 4b-9a
  '98101': '9a', // Seattle
  '99201': '6a', // Spokane
  '98801': '6a', // Wenatchee
  '98936': '4b', // Yakima
  
  // WEST VIRGINIA - Zones 5a-6b
  '25301': '6a', // Charleston
  '26505': '6a', // Morgantown
  '25401': '6b', // Martinsburg
  
  // WISCONSIN - Zones 3b-5a
  '53202': '5a', // Milwaukee
  '53703': '4b', // Madison
  '54601': '4a', // La Crosse
  '54868': '3b', // Superior
  
  // WYOMING - Zones 3a-5a
  '82001': '5a', // Cheyenne
  '82601': '4a', // Casper
  '83001': '3a', // Jackson
  '82414': '4a', // Cody
};

// Get state from zip code (first 3 digits approximation for major metros)
export const getStateFromZip = (zipCode) => {
  const zip3 = zipCode.substring(0, 3);
  
  // Major metro area zip code prefixes to state mapping
  const zip3ToState = {
    // Northeast
    '010': 'Massachusetts', '011': 'Massachusetts', '012': 'Massachusetts', '013': 'Massachusetts', '014': 'Massachusetts', '015': 'Massachusetts', '016': 'Massachusetts', '017': 'Massachusetts', '018': 'Massachusetts', '019': 'Massachusetts',
    '020': 'Massachusetts', '021': 'Massachusetts', '022': 'Massachusetts', '023': 'Massachusetts', '024': 'Massachusetts', '025': 'Massachusetts', '026': 'Massachusetts', '027': 'Massachusetts',
    '028': 'Rhode Island', '029': 'Rhode Island',
    '030': 'New Hampshire', '031': 'New Hampshire', '032': 'New Hampshire', '033': 'New Hampshire', '034': 'New Hampshire', '035': 'New Hampshire', '036': 'New Hampshire', '037': 'New Hampshire', '038': 'New Hampshire',
    '039': 'Maine', '040': 'Maine', '041': 'Maine', '042': 'Maine', '043': 'Maine', '044': 'Maine', '045': 'Maine', '046': 'Maine', '047': 'Maine', '048': 'Maine', '049': 'Maine',
    '050': 'Vermont', '051': 'Vermont', '052': 'Vermont', '053': 'Vermont', '054': 'Vermont', '055': 'Vermont', '056': 'Vermont', '057': 'Vermont', '058': 'Vermont', '059': 'Vermont',
    '060': 'Connecticut', '061': 'Connecticut', '062': 'Connecticut', '063': 'Connecticut', '064': 'Connecticut', '065': 'Connecticut', '066': 'Connecticut', '067': 'Connecticut', '068': 'Connecticut', '069': 'Connecticut',
    '070': 'New Jersey', '071': 'New Jersey', '072': 'New Jersey', '073': 'New Jersey', '074': 'New Jersey', '075': 'New Jersey', '076': 'New Jersey', '077': 'New Jersey', '078': 'New Jersey', '079': 'New Jersey', '080': 'New Jersey', '081': 'New Jersey', '082': 'New Jersey', '083': 'New Jersey', '084': 'New Jersey', '085': 'New Jersey', '086': 'New Jersey', '087': 'New Jersey', '088': 'New Jersey', '089': 'New Jersey',
    '100': 'New York', '101': 'New York', '102': 'New York', '103': 'New York', '104': 'New York', '105': 'New York', '106': 'New York', '107': 'New York', '108': 'New York', '109': 'New York', '110': 'New York', '111': 'New York', '112': 'New York', '113': 'New York', '114': 'New York', '115': 'New York', '116': 'New York', '117': 'New York', '118': 'New York', '119': 'New York', '120': 'New York', '121': 'New York', '122': 'New York', '123': 'New York', '124': 'New York', '125': 'New York', '126': 'New York', '127': 'New York', '128': 'New York', '129': 'New York', '130': 'New York', '131': 'New York', '132': 'New York', '133': 'New York', '134': 'New York', '135': 'New York', '136': 'New York', '137': 'New York', '138': 'New York', '139': 'New York', '140': 'New York', '141': 'New York', '142': 'New York', '143': 'New York', '144': 'New York', '145': 'New York', '146': 'New York', '147': 'New York', '148': 'New York', '149': 'New York',
    // Mid-Atlantic
    '150': 'Pennsylvania', '151': 'Pennsylvania', '152': 'Pennsylvania', '153': 'Pennsylvania', '154': 'Pennsylvania', '155': 'Pennsylvania', '156': 'Pennsylvania', '157': 'Pennsylvania', '158': 'Pennsylvania', '159': 'Pennsylvania', '160': 'Pennsylvania', '161': 'Pennsylvania', '162': 'Pennsylvania', '163': 'Pennsylvania', '164': 'Pennsylvania', '165': 'Pennsylvania', '166': 'Pennsylvania', '167': 'Pennsylvania', '168': 'Pennsylvania', '169': 'Pennsylvania', '170': 'Pennsylvania', '171': 'Pennsylvania', '172': 'Pennsylvania', '173': 'Pennsylvania', '174': 'Pennsylvania', '175': 'Pennsylvania', '176': 'Pennsylvania', '177': 'Pennsylvania', '178': 'Pennsylvania', '179': 'Pennsylvania', '180': 'Pennsylvania', '181': 'Pennsylvania', '182': 'Pennsylvania', '183': 'Pennsylvania', '184': 'Pennsylvania', '185': 'Pennsylvania', '186': 'Pennsylvania', '187': 'Pennsylvania', '188': 'Pennsylvania', '189': 'Pennsylvania', '190': 'Pennsylvania', '191': 'Pennsylvania', '192': 'Pennsylvania', '193': 'Pennsylvania', '194': 'Pennsylvania', '195': 'Pennsylvania', '196': 'Pennsylvania',
    '197': 'Delaware', '198': 'Delaware', '199': 'Delaware',
    '200': 'Maryland', '201': 'Maryland', '202': 'Maryland', '203': 'Maryland', '204': 'Maryland', '205': 'Maryland', '206': 'Maryland', '207': 'Maryland', '208': 'Maryland', '209': 'Maryland', '210': 'Maryland', '211': 'Maryland', '212': 'Maryland',
    // Southeast
    '220': 'Virginia', '221': 'Virginia', '222': 'Virginia', '223': 'Virginia', '224': 'Virginia', '225': 'Virginia', '226': 'Virginia', '227': 'Virginia', '228': 'Virginia', '229': 'Virginia', '230': 'Virginia', '231': 'Virginia', '232': 'Virginia', '233': 'Virginia', '234': 'Virginia', '235': 'Virginia', '236': 'Virginia', '237': 'Virginia', '238': 'Virginia', '239': 'Virginia', '240': 'Virginia', '241': 'Virginia', '242': 'Virginia', '243': 'Virginia', '244': 'Virginia', '245': 'Virginia', '246': 'Virginia',
    '247': 'West Virginia', '248': 'West Virginia', '249': 'West Virginia', '250': 'West Virginia', '251': 'West Virginia', '252': 'West Virginia', '253': 'West Virginia', '254': 'West Virginia', '255': 'West Virginia', '256': 'West Virginia', '257': 'West Virginia', '258': 'West Virginia', '259': 'West Virginia', '260': 'West Virginia', '261': 'West Virginia', '262': 'West Virginia', '263': 'West Virginia', '264': 'West Virginia', '265': 'West Virginia', '266': 'West Virginia', '267': 'West Virginia', '268': 'West Virginia',
    '270': 'North Carolina', '271': 'North Carolina', '272': 'North Carolina', '273': 'North Carolina', '274': 'North Carolina', '275': 'North Carolina', '276': 'North Carolina', '277': 'North Carolina', '278': 'North Carolina', '279': 'North Carolina', '280': 'North Carolina', '281': 'North Carolina', '282': 'North Carolina', '283': 'North Carolina', '284': 'North Carolina', '285': 'North Carolina', '286': 'North Carolina', '287': 'North Carolina', '288': 'North Carolina', '289': 'North Carolina',
    '290': 'South Carolina', '291': 'South Carolina', '292': 'South Carolina', '293': 'South Carolina', '294': 'South Carolina', '295': 'South Carolina', '296': 'South Carolina', '297': 'South Carolina', '298': 'South Carolina', '299': 'South Carolina',
    '300': 'Georgia', '301': 'Georgia', '302': 'Georgia', '303': 'Georgia', '304': 'Georgia', '305': 'Georgia', '306': 'Georgia', '307': 'Georgia', '308': 'Georgia', '309': 'Georgia', '310': 'Georgia', '311': 'Georgia', '312': 'Georgia', '313': 'Georgia', '314': 'Georgia', '315': 'Georgia', '316': 'Georgia', '317': 'Georgia', '318': 'Georgia', '319': 'Georgia',
    '320': 'Florida', '321': 'Florida', '322': 'Florida', '323': 'Florida', '324': 'Florida', '325': 'Florida', '326': 'Florida', '327': 'Florida', '328': 'Florida', '329': 'Florida', '330': 'Florida', '331': 'Florida', '332': 'Florida', '333': 'Florida', '334': 'Florida', '335': 'Florida', '336': 'Florida', '337': 'Florida', '338': 'Florida', '339': 'Florida', '340': 'Florida', '341': 'Florida', '342': 'Florida', '343': 'Florida', '344': 'Florida', '345': 'Florida', '346': 'Florida', '347': 'Florida',
    '350': 'Alabama', '351': 'Alabama', '352': 'Alabama', '353': 'Alabama', '354': 'Alabama', '355': 'Alabama', '356': 'Alabama', '357': 'Alabama', '358': 'Alabama', '359': 'Alabama', '360': 'Alabama', '361': 'Alabama', '362': 'Alabama', '363': 'Alabama', '364': 'Alabama', '365': 'Alabama', '366': 'Alabama', '367': 'Alabama', '368': 'Alabama', '369': 'Alabama',
    '370': 'Tennessee', '371': 'Tennessee', '372': 'Tennessee', '373': 'Tennessee', '374': 'Tennessee', '375': 'Tennessee', '376': 'Tennessee', '377': 'Tennessee', '378': 'Tennessee', '379': 'Tennessee', '380': 'Tennessee', '381': 'Tennessee', '382': 'Tennessee', '383': 'Tennessee', '384': 'Tennessee', '385': 'Tennessee',
    '386': 'Mississippi', '387': 'Mississippi', '388': 'Mississippi', '389': 'Mississippi', '390': 'Mississippi', '391': 'Mississippi', '392': 'Mississippi', '393': 'Mississippi', '394': 'Mississippi', '395': 'Mississippi', '396': 'Mississippi', '397': 'Mississippi',
    '398': 'Kentucky', '399': 'Kentucky', '400': 'Kentucky', '401': 'Kentucky', '402': 'Kentucky', '403': 'Kentucky', '404': 'Kentucky', '405': 'Kentucky', '406': 'Kentucky', '407': 'Kentucky', '408': 'Kentucky', '409': 'Kentucky', '410': 'Kentucky', '411': 'Kentucky', '412': 'Kentucky', '413': 'Kentucky', '414': 'Kentucky', '415': 'Kentucky', '416': 'Kentucky', '417': 'Kentucky', '418': 'Kentucky', '419': 'Kentucky', '420': 'Kentucky', '421': 'Kentucky', '422': 'Kentucky', '423': 'Kentucky', '424': 'Kentucky', '425': 'Kentucky', '426': 'Kentucky', '427': 'Kentucky',
    // Midwest
    '430': 'Ohio', '431': 'Ohio', '432': 'Ohio', '433': 'Ohio', '434': 'Ohio', '435': 'Ohio', '436': 'Ohio', '437': 'Ohio', '438': 'Ohio', '439': 'Ohio', '440': 'Ohio', '441': 'Ohio', '442': 'Ohio', '443': 'Ohio', '444': 'Ohio', '445': 'Ohio', '446': 'Ohio', '447': 'Ohio', '448': 'Ohio', '449': 'Ohio', '450': 'Ohio', '451': 'Ohio', '452': 'Ohio', '453': 'Ohio', '454': 'Ohio', '455': 'Ohio', '456': 'Ohio', '457': 'Ohio', '458': 'Ohio',
    '460': 'Indiana', '461': 'Indiana', '462': 'Indiana', '463': 'Indiana', '464': 'Indiana', '465': 'Indiana', '466': 'Indiana', '467': 'Indiana', '468': 'Indiana', '469': 'Indiana', '470': 'Indiana', '471': 'Indiana', '472': 'Indiana', '473': 'Indiana', '474': 'Indiana', '475': 'Indiana', '476': 'Indiana', '477': 'Indiana', '478': 'Indiana', '479': 'Indiana',
    '480': 'Michigan', '481': 'Michigan', '482': 'Michigan', '483': 'Michigan', '484': 'Michigan', '485': 'Michigan', '486': 'Michigan', '487': 'Michigan', '488': 'Michigan', '489': 'Michigan', '490': 'Michigan', '491': 'Michigan', '492': 'Michigan', '493': 'Michigan', '494': 'Michigan', '495': 'Michigan', '496': 'Michigan', '497': 'Michigan', '498': 'Michigan', '499': 'Michigan',
    '500': 'Iowa', '501': 'Iowa', '502': 'Iowa', '503': 'Iowa', '504': 'Iowa', '505': 'Iowa', '506': 'Iowa', '507': 'Iowa', '508': 'Iowa', '510': 'Iowa', '511': 'Iowa', '512': 'Iowa', '513': 'Iowa', '514': 'Iowa', '515': 'Iowa', '516': 'Iowa', '520': 'Iowa', '521': 'Iowa', '522': 'Iowa', '523': 'Iowa', '524': 'Iowa', '525': 'Iowa', '526': 'Iowa', '527': 'Iowa', '528': 'Iowa',
    '530': 'Wisconsin', '531': 'Wisconsin', '532': 'Wisconsin', '534': 'Wisconsin', '535': 'Wisconsin', '537': 'Wisconsin', '538': 'Wisconsin', '539': 'Wisconsin', '540': 'Wisconsin', '541': 'Wisconsin', '542': 'Wisconsin', '543': 'Wisconsin', '544': 'Wisconsin', '545': 'Wisconsin', '546': 'Wisconsin', '547': 'Wisconsin', '548': 'Wisconsin', '549': 'Wisconsin',
    '550': 'Minnesota', '551': 'Minnesota', '553': 'Minnesota', '554': 'Minnesota', '555': 'Minnesota', '556': 'Minnesota', '557': 'Minnesota', '558': 'Minnesota', '559': 'Minnesota', '560': 'Minnesota', '561': 'Minnesota', '562': 'Minnesota', '563': 'Minnesota', '564': 'Minnesota', '565': 'Minnesota', '566': 'Minnesota', '567': 'Minnesota',
    '570': 'South Dakota', '571': 'South Dakota', '572': 'South Dakota', '573': 'South Dakota', '574': 'South Dakota', '575': 'South Dakota', '576': 'South Dakota', '577': 'South Dakota',
    '580': 'North Dakota', '581': 'North Dakota', '582': 'North Dakota', '583': 'North Dakota', '584': 'North Dakota', '585': 'North Dakota', '586': 'North Dakota', '587': 'North Dakota', '588': 'North Dakota',
    '590': 'Montana', '591': 'Montana', '592': 'Montana', '593': 'Montana', '594': 'Montana', '595': 'Montana', '596': 'Montana', '597': 'Montana', '598': 'Montana', '599': 'Montana',
    // Central
    '600': 'Illinois', '601': 'Illinois', '602': 'Illinois', '603': 'Illinois', '604': 'Illinois', '605': 'Illinois', '606': 'Illinois', '607': 'Illinois', '608': 'Illinois', '609': 'Illinois', '610': 'Illinois', '611': 'Illinois', '612': 'Illinois', '613': 'Illinois', '614': 'Illinois', '615': 'Illinois', '616': 'Illinois', '617': 'Illinois', '618': 'Illinois', '619': 'Illinois', '620': 'Illinois', '621': 'Illinois', '622': 'Illinois', '623': 'Illinois', '624': 'Illinois', '625': 'Illinois', '626': 'Illinois', '627': 'Illinois', '628': 'Illinois', '629': 'Illinois',
    '630': 'Missouri', '631': 'Missouri', '632': 'Missouri', '633': 'Missouri', '634': 'Missouri', '635': 'Missouri', '636': 'Missouri', '637': 'Missouri', '638': 'Missouri', '639': 'Missouri', '640': 'Missouri', '641': 'Missouri', '644': 'Missouri', '645': 'Missouri', '646': 'Missouri', '647': 'Missouri', '648': 'Missouri', '649': 'Missouri', '650': 'Missouri', '651': 'Missouri', '652': 'Missouri', '653': 'Missouri', '654': 'Missouri', '655': 'Missouri', '656': 'Missouri', '657': 'Missouri', '658': 'Missouri',
    '660': 'Kansas', '661': 'Kansas', '662': 'Kansas', '664': 'Kansas', '665': 'Kansas', '666': 'Kansas', '667': 'Kansas', '668': 'Kansas', '669': 'Kansas', '670': 'Kansas', '671': 'Kansas', '672': 'Kansas', '673': 'Kansas', '674': 'Kansas', '675': 'Kansas', '676': 'Kansas', '677': 'Kansas', '678': 'Kansas', '679': 'Kansas',
    '680': 'Nebraska', '681': 'Nebraska', '683': 'Nebraska', '684': 'Nebraska', '685': 'Nebraska', '686': 'Nebraska', '687': 'Nebraska', '688': 'Nebraska', '689': 'Nebraska', '690': 'Nebraska', '691': 'Nebraska', '692': 'Nebraska', '693': 'Nebraska',
    '700': 'Louisiana', '701': 'Louisiana', '703': 'Louisiana', '704': 'Louisiana', '705': 'Louisiana', '706': 'Louisiana', '707': 'Louisiana', '708': 'Louisiana', '710': 'Louisiana', '711': 'Louisiana', '712': 'Louisiana', '713': 'Louisiana', '714': 'Louisiana',
    '716': 'Arkansas', '717': 'Arkansas', '718': 'Arkansas', '719': 'Arkansas', '720': 'Arkansas', '721': 'Arkansas', '722': 'Arkansas', '723': 'Arkansas', '724': 'Arkansas', '725': 'Arkansas', '726': 'Arkansas', '727': 'Arkansas', '728': 'Arkansas', '729': 'Arkansas',
    '730': 'Oklahoma', '731': 'Oklahoma', '733': 'Oklahoma', '734': 'Oklahoma', '735': 'Oklahoma', '736': 'Oklahoma', '737': 'Oklahoma', '738': 'Oklahoma', '739': 'Oklahoma', '740': 'Oklahoma', '741': 'Oklahoma', '743': 'Oklahoma', '744': 'Oklahoma', '745': 'Oklahoma', '746': 'Oklahoma', '747': 'Oklahoma', '748': 'Oklahoma', '749': 'Oklahoma',
    '750': 'Texas', '751': 'Texas', '752': 'Texas', '753': 'Texas', '754': 'Texas', '755': 'Texas', '756': 'Texas', '757': 'Texas', '758': 'Texas', '759': 'Texas', '760': 'Texas', '761': 'Texas', '762': 'Texas', '763': 'Texas', '764': 'Texas', '765': 'Texas', '766': 'Texas', '767': 'Texas', '768': 'Texas', '769': 'Texas', '770': 'Texas', '771': 'Texas', '772': 'Texas', '773': 'Texas', '774': 'Texas', '775': 'Texas', '776': 'Texas', '777': 'Texas', '778': 'Texas', '779': 'Texas', '780': 'Texas', '781': 'Texas', '782': 'Texas', '783': 'Texas', '784': 'Texas', '785': 'Texas', '786': 'Texas', '787': 'Texas', '788': 'Texas', '789': 'Texas', '790': 'Texas', '791': 'Texas', '792': 'Texas', '793': 'Texas', '794': 'Texas', '795': 'Texas', '796': 'Texas', '797': 'Texas', '798': 'Texas', '799': 'Texas',
    // Mountain West
    '800': 'Colorado', '801': 'Colorado', '802': 'Colorado', '803': 'Colorado', '804': 'Colorado', '805': 'Colorado', '806': 'Colorado', '807': 'Colorado', '808': 'Colorado', '809': 'Colorado', '810': 'Colorado', '811': 'Colorado', '812': 'Colorado', '813': 'Colorado', '814': 'Colorado', '815': 'Colorado', '816': 'Colorado',
    '820': 'Wyoming', '821': 'Wyoming', '822': 'Wyoming', '823': 'Wyoming', '824': 'Wyoming', '825': 'Wyoming', '826': 'Wyoming', '827': 'Wyoming', '828': 'Wyoming', '829': 'Wyoming', '830': 'Wyoming', '831': 'Wyoming',
    '832': 'Idaho', '833': 'Idaho', '834': 'Idaho', '835': 'Idaho', '836': 'Idaho', '837': 'Idaho', '838': 'Idaho',
    '840': 'Utah', '841': 'Utah', '842': 'Utah', '843': 'Utah', '844': 'Utah', '845': 'Utah', '846': 'Utah', '847': 'Utah',
    '850': 'Arizona', '851': 'Arizona', '852': 'Arizona', '853': 'Arizona', '855': 'Arizona', '856': 'Arizona', '857': 'Arizona', '859': 'Arizona', '860': 'Arizona', '863': 'Arizona', '864': 'Arizona', '865': 'Arizona',
    '870': 'New Mexico', '871': 'New Mexico', '872': 'New Mexico', '873': 'New Mexico', '874': 'New Mexico', '875': 'New Mexico', '877': 'New Mexico', '878': 'New Mexico', '879': 'New Mexico', '880': 'New Mexico', '881': 'New Mexico', '882': 'New Mexico', '883': 'New Mexico', '884': 'New Mexico',
    '889': 'Nevada', '890': 'Nevada', '891': 'Nevada', '893': 'Nevada', '894': 'Nevada', '895': 'Nevada', '896': 'Nevada', '897': 'Nevada', '898': 'Nevada',
    // Pacific
    '900': 'California', '901': 'California', '902': 'California', '903': 'California', '904': 'California', '905': 'California', '906': 'California', '907': 'California', '908': 'California', '910': 'California', '911': 'California', '912': 'California', '913': 'California', '914': 'California', '915': 'California', '916': 'California', '917': 'California', '918': 'California', '919': 'California', '920': 'California', '921': 'California', '922': 'California', '923': 'California', '924': 'California', '925': 'California', '926': 'California', '927': 'California', '928': 'California', '930': 'California', '931': 'California', '932': 'California', '933': 'California', '934': 'California', '935': 'California', '936': 'California', '937': 'California', '938': 'California', '939': 'California', '940': 'California', '941': 'California', '942': 'California', '943': 'California', '944': 'California', '945': 'California', '946': 'California', '947': 'California', '948': 'California', '949': 'California', '950': 'California', '951': 'California', '952': 'California', '953': 'California', '954': 'California', '955': 'California', '956': 'California', '957': 'California', '958': 'California', '959': 'California', '960': 'California', '961': 'California',
    '967': 'Hawaii', '968': 'Hawaii',
    '970': 'Oregon', '971': 'Oregon', '972': 'Oregon', '973': 'Oregon', '974': 'Oregon', '975': 'Oregon', '976': 'Oregon', '977': 'Oregon', '978': 'Oregon', '979': 'Oregon',
    '980': 'Washington', '981': 'Washington', '982': 'Washington', '983': 'Washington', '984': 'Washington', '985': 'Washington', '986': 'Washington', '988': 'Washington', '989': 'Washington', '990': 'Washington', '991': 'Washington', '992': 'Washington', '993': 'Washington', '994': 'Washington',
    '995': 'Alaska', '996': 'Alaska', '997': 'Alaska', '998': 'Alaska', '999': 'Alaska'
  };
  
  return zip3ToState[zip3] || null;
};

// Main function to get hardiness zone from zip code
export const getZoneFromZipCode = (zipCode) => {
  if (!zipCode || zipCode.length < 5) {
    return null;
  }
  
  // Clean zip code (remove any non-numeric characters)
  const cleanZip = zipCode.replace(/\D/g, '').substring(0, 5);
  
  // First try exact match
  if (zipCodeZoneMapping[cleanZip]) {
    return zipCodeZoneMapping[cleanZip];
  }
  
  // If no exact match, try to get state and use default zone
  const state = getStateFromZip(cleanZip);
  if (state) {
    // Import and use the state zone mapping
    const { stateZoneMapping } = require('./hardinessZones');
    const zones = stateZoneMapping[state];
    if (zones && zones.length > 0) {
      // Return the first (most common) zone for the state
      return zones[0];
    }
  }
  
  // Ultimate fallback
  return '6a';
};

// Helper function to validate zip code format
export const isValidZipCode = (zipCode) => {
  if (!zipCode) return false;
  const cleanZip = zipCode.replace(/\D/g, '');
  return cleanZip.length === 5 || cleanZip.length === 9;
};